const getUserProfileUrl = '/staff/users/me/';

export default getUserProfileUrl;
